import * as yup from 'yup'
import { _regularExpressions } from '../Services/_regularExpressions';
import { parse, isValid } from 'date-fns';
import { enGB } from 'date-fns/locale';

export const _detailState = (function () {
  let foreName = "";
  let surName = "";
  let gender = "";
  let dob = "";
  let dobDay = "";
  let dobMonth = "";
  let dobYear = "";
  let approximateAge = "";
  let addressYesOrNo = "";
  let isAddressInLeeds = "";
  let postCode = "";
  let ddlAddress = "";
  let addressUPRN = "";
  let isAddressManual = false;
  let manualAddressInput = "";
  let personAddressInfo = "";
  let addressDetail = "";
  let emailYesOrNo = "";
  let personsEmail = "";
  let mainContactYesOrNo = "";
  let personsMainContactNo = "";
  let alternateContactYesOrNo = "";
  let alternateContactNo = "";
  let alternateContactNoDetail = "";
  let nhsNumber = "";
  let ethnicOrigin = "";
  let languageSpoken = "";
  let interpreter = "";
  let communicationNeeds = "";
  let communicationNeedsDetail = "";
  let healthConditions = [];

  const getForeName = function () { return foreName; };
  const setForeName = function (name) { foreName = name; };
  const getSurName = function () { return surName; };
  const setSurName = function (name) { surName = name; };
  const getGender = function () { return gender; };
  const setGender = function (name) { gender = name; };
  const getDob = function () { return dob; };
  const setDob = function (name) { dob = name; };
  const getDobDay = function () { return dobDay; };
  const setDobDay = function (name) { dobDay = name; };
  const getDobMonth = function () { return dobMonth; };
  const setDobMonth = function (name) { dobMonth = name; };
  const getDobYear = function () { return dobYear; };
  const setDobYear = function (name) { dobYear = name; };
  const getApproximateAge = function () { return approximateAge; };
  const setApproximateAge = function (name) { approximateAge = name; };
  const getAddressYesOrNo = function () { return addressYesOrNo; };
  const setAddressYesOrNo = function (name) { addressYesOrNo = name; };
  const getIsAddressInLeeds = function () { return isAddressInLeeds; };
  const setIsAddressInLeeds = function (name) { isAddressInLeeds = name; };
  const getPostCode = function () { return postCode; };
  const setPostCode = function (name) { postCode = name.trim(); };
  const getDdlAddress = function () { return ddlAddress; };
  const setDdlAddress = function (name) { ddlAddress = name; };
  const getAddressUPRN = function () { return addressUPRN; };
  const setAddressUPRN = function (name) { addressUPRN = name; };
  const getIsAddressManual = function () { return isAddressManual; };
  const setIsAddressManual = function (name) { isAddressManual = name; };
  const getManualAddressInput = function () { return manualAddressInput; };
  const setManualAddressInput = function (name) { manualAddressInput = name; };
  const getPersonAddressInfo = function () { return personAddressInfo; };
  const setPersonAddressInfo = function (name) { personAddressInfo = name; };
  const getAddressDetail = function () { return addressDetail; };
  const setAddressDetail = function (name) { addressDetail = name; };
  const getEmailYesOrNo = function () { return emailYesOrNo; };
  const setEmailYesOrNo = function (name) { emailYesOrNo = name; };
  const getPersonsEmail = function () { return personsEmail; };
  const setPersonsEmail = function (name) { personsEmail = name; };
  const getMainContactYesOrNo = function () { return mainContactYesOrNo; };
  const setMainContactYesOrNo = function (name) { mainContactYesOrNo = name; };
  const getPersonsMainContactNo = function () { return personsMainContactNo; };
  const setPersonsMainContactNo = function (name) { personsMainContactNo = name; };
  const getAlternateContactYesOrNo = function () { return alternateContactYesOrNo; };
  const setAlternateContactYesOrNo = function (name) { alternateContactYesOrNo = name; };
  const getAlternateContactNo = function () { return alternateContactNo; };
  const setAlternateContactNo = function (name) { alternateContactNo = name; };
  const getAlternateContactNoDetail = function () { return alternateContactNoDetail; };
  const setAlternateContactNoDetail = function (name) { alternateContactNoDetail = name; };
  const getNhsNumber = function () { return nhsNumber; };
  const setNhsNumber = function (name) { nhsNumber = name; };
  const getEthnicOrigin = function () { return ethnicOrigin; };
  const setEthnicOrigin = function (name) { ethnicOrigin = name; };
  const getLanguageSpoken = function () { return languageSpoken; };
  const setLanguageSpoken = function (name) { languageSpoken = name; };
  const getInterpreter = function () { return interpreter; };
  const setInterpreter = function (name) { interpreter = name; };
  const getCommunicationNeeds = function () { return communicationNeeds; };
  const setCommunicationNeeds = function (name) { communicationNeeds = name; };
  const getCommunicationNeedsDetail = function () { return communicationNeedsDetail; };
  const setCommunicationNeedsDetail = function (name) { communicationNeedsDetail = name; };
  const getHealthConditions = function () { return healthConditions; };
  const setHealthConditions = function (name) { healthConditions = name; };

  const resetDetailState = function () {
    setForeName("");
    setSurName("");
    setGender("");
    setDob("");
    setDobDay("");
    setDobMonth("");
    setDobYear("");
    setApproximateAge("");
    setAddressYesOrNo("");
    setIsAddressInLeeds("");
    setPostCode("");
    setDdlAddress("");
    setAddressUPRN("");
    setIsAddressManual(false);
    setManualAddressInput("");
    setPersonAddressInfo("");
    setAddressDetail("");
    setEmailYesOrNo("");
    setPersonsEmail("");
    setMainContactYesOrNo("");
    setPersonsMainContactNo("");
    setAlternateContactYesOrNo("");
    setAlternateContactNo("");
    setAlternateContactNoDetail("");
    setNhsNumber("");
    setEthnicOrigin("");
    setLanguageSpoken("");
    setInterpreter("");
    setCommunicationNeeds("");
    setCommunicationNeedsDetail("");
    setHealthConditions("");
  };

  return {
    getForeName: getForeName,
    setForeName: setForeName,
    getSurName: getSurName,
    setSurName: setSurName,
    getGender: getGender,
    setGender: setGender,
    getDob: getDob,
    setDob: setDob,
    getDobDay: getDobDay,
    setDobDay: setDobDay,
    getDobMonth: getDobMonth,
    setDobMonth: setDobMonth,
    getDobYear: getDobYear,
    setDobYear: setDobYear,
    getApproximateAge: getApproximateAge,
    setApproximateAge: setApproximateAge,
    getAddressYesOrNo: getAddressYesOrNo,
    setAddressYesOrNo: setAddressYesOrNo,
    getIsAddressInLeeds:getIsAddressInLeeds,
    setIsAddressInLeeds:setIsAddressInLeeds,
    getPostCode: getPostCode,
    setPostCode: setPostCode,
    getDdlAddress: getDdlAddress,
    setDdlAddress: setDdlAddress,
    getAddressUPRN: getAddressUPRN,
    setAddressUPRN: setAddressUPRN,
    getIsAddressManual:getIsAddressManual,
    setIsAddressManual:setIsAddressManual,
    getManualAddressInput:getManualAddressInput,
    setManualAddressInput:setManualAddressInput,
    getPersonAddressInfo:getPersonAddressInfo,
    setPersonAddressInfo:setPersonAddressInfo,
    getAddressDetail: getAddressDetail,
    setAddressDetail: setAddressDetail,
    getEmailYesOrNo: getEmailYesOrNo,
    setEmailYesOrNo: setEmailYesOrNo,
    getPersonsEmail: getPersonsEmail,
    setPersonsEmail: setPersonsEmail,
    getMainContactYesOrNo: getMainContactYesOrNo,
    setMainContactYesOrNo: setMainContactYesOrNo,
    getPersonsMainContactNo: getPersonsMainContactNo,
    setPersonsMainContactNo: setPersonsMainContactNo,
    getAlternateContactYesOrNo: getAlternateContactYesOrNo,
    setAlternateContactYesOrNo: setAlternateContactYesOrNo,
    getAlternateContactNo: getAlternateContactNo,
    setAlternateContactNo: setAlternateContactNo,
    getAlternateContactNoDetail: getAlternateContactNoDetail,
    setAlternateContactNoDetail: setAlternateContactNoDetail,
    getNhsNumber: getNhsNumber,
    setNhsNumber: setNhsNumber,
    getEthnicOrigin: getEthnicOrigin,
    setEthnicOrigin: setEthnicOrigin,
    getLanguageSpoken: getLanguageSpoken,
    setLanguageSpoken: setLanguageSpoken,
    getInterpreter: getInterpreter,
    setInterpreter: setInterpreter,
    getCommunicationNeeds: getCommunicationNeeds,
    setCommunicationNeeds: setCommunicationNeeds,
    getCommunicationNeedsDetail: getCommunicationNeedsDetail,
    setCommunicationNeedsDetail: setCommunicationNeedsDetail,
    getHealthConditions: getHealthConditions,
    setHealthConditions: setHealthConditions,
    resetDetailState: resetDetailState
  }
})();

const yupValidation = yup.object().shape({
  foreName: yup.string().trim()
    .required("Enter the forename of the person being referred")
    .matches(_regularExpressions.letterPattern, 'Forename is not valid')
    .max(36, (validationObj) => {return `Forename must be ${validationObj.max} characters or less`}),
  surName: yup.string().trim()
    .required("Enter the surname of the person being referred")
    .matches(_regularExpressions.letterPattern, 'Surname is not valid')
    .max(36, (validationObj) => {return `Surname must be ${validationObj.max} characters or less`}),
  gender: yup.string().trim()
    .required("Select the gender of the person being referred")
    .nullable(),

  dobDay: yup.string().trim()
    .matches(_regularExpressions.numbersPattern, 'Enter a valid day example(01-31)')
    .nullable(),
  dobMonth: yup.string().trim()
    .matches(_regularExpressions.numbersPattern, 'Enter a valid month example(01-12)')
    .nullable(),
  dobYear: yup.string().trim()
    .matches(_regularExpressions.numbersPattern, 'Enter a valid year')
    .nullable(),

  approximateAge: yup.string().ensure().when(['dobDay','dobMonth','dobYear'], {
    is: (dobDay,dobMonth,dobYear) => dobDay.trim().length === 0 && dobMonth.trim().length === 0 && dobYear.trim().length === 0,
    then: yup.string().trim()
            .required("Enter an approximate age")
  }),

  addressYesOrNo: yup.string().trim()
                    .required("Select yes if you know the address of the person being referred")
                    .nullable(),
  emailYesOrNo: yup.string().trim()
                    .required("Select if you know they have an email")
                    .nullable(),
  mainContactYesOrNo: yup.string().trim()
                          .required("Select if you know the main contact number of the person")
                          .nullable(),
  alternateContactYesOrNo: yup.string().trim()
                              .required("Select if you know the alternate contact number of the person")
                              .nullable(),
  nhsNumber: yup.string().trim()
                .matches(_regularExpressions.nhsNumberPattern, 'Enter the 10 digit NHS number'),
  interpreter: yup.string().trim()
                  .required("Select if you know the person needs an interpreter")
                  .nullable(),
  communicationNeeds: yup.string().trim()
                        .required("Select if you know the person has any specific communication needs")
                        .nullable(),
  
  isAddressInLeeds: yup.string().trim().ensure().when('addressYesOrNo', {
    is: (addressYesOrNo) => addressYesOrNo === 'yes',
    then: yup.string().trim()
              .required("Select yes if the address is in Leeds")
  }),

  personAddressInfo: yup.string().trim().ensure().when('isAddressInLeeds', {
    is: (isAddressInLeeds) => isAddressInLeeds === 'no',
    then: yup.string().trim()
              .max(250, (validationObj) => {return `Address must be ${validationObj.max} characters or less`})
              .required("Enter more detail")
  }),
                        
  postCode: yup.string().trim().ensure().when('isAddressInLeeds', {
    is: (isAddressInLeeds) => isAddressInLeeds === 'yes',
    then: yup.string().trim()
              .required("Enter a valid Leeds postcode")
              .matches(_regularExpressions.postcodePattern, _regularExpressions.postcodePatternError)
  }),

  addressDetail: yup.string().trim().ensure().when('addressYesOrNo', {
    is: (addressYesOrNo) => addressYesOrNo === 'no',
    then: yup.string().trim()
      .required("Enter more detail")
      .max(200, (validationObj) => {return `Explanation must be ${validationObj.max} characters or less`}),
  }),

  personsEmail: yup.string().trim().ensure().when('emailYesOrNo', {
    is: (emailYesOrNo) => emailYesOrNo === 'yes',
    then: yup.string().trim()
              .max(50, (validationObj) => {return `Email must be ${validationObj.max} characters or less`})
              .required("Enter the email address for the person being referred")
              .matches(_regularExpressions.emailPattern, _regularExpressions.emailPatternError),
  }),

  personsMainContactNo: yup.string().trim().ensure().when('mainContactYesOrNo', {
    is: (mainContactYesOrNo) => mainContactYesOrNo === 'yes',
    then: yup.string().trim()
      .required("Enter a contact number for the person being referred")
      .matches(_regularExpressions.phonePattern, _regularExpressions.phonePatternError)
      .max(16, (validationObj) => {return `Contact number must be ${validationObj.max} characters or less`}),
    }),

  alternateContactNo: yup.string().trim().ensure().when('alternateContactYesOrNo', {
    is: (alternateContactYesOrNo) => alternateContactYesOrNo === 'yes',
    then: yup.string().trim().required("Enter an alternative contact number for the person being referred")
      .matches(_regularExpressions.phonePattern, _regularExpressions.phonePatternError)
      .max(16, (validationObj) => {return `Alternative contact number must be ${validationObj.max} characters or less`}),
    }),

  alternateContactNoDetail: yup.string().trim().ensure().when('alternateContactYesOrNo', {
    is: (alternateContactYesOrNo) => alternateContactYesOrNo === 'yes',
    then: yup.string().trim()
              .required("Enter details to the nature of contact for the person being referred")
              .max(200, (validationObj) => {return `Explanation you provide must be ${validationObj.max} characters or less`})
  }),

  communicationNeedsDetail: yup.string().trim().ensure().when('communicationNeeds', {
    is: (communicationNeeds) => communicationNeeds === 'yes',
    then: yup.string().trim()
              .required("Enter details about any specific communication needs")
              .max(200, (validationObj) => {return `Explanation you provide must be ${validationObj.max} characters or less`})
  }),
}
)
  .when((value, schema) => {
    const ethinic = _detailState.getEthnicOrigin();
    if (ethinic.length === 0) {
      return schema.shape({
        ethnicOrigin: yup.string().trim()
                          .required("Select the ethnic origin of the person being referred"),
      });
    }

  })
  .when((value, schema) => {
    let health = _detailState.getHealthConditions();
    let healthList = [];
    health?.map((h) => { healthList.push(h) });
    if (healthList.length === 0) {
      return schema.shape({
        healthConditions: yup.object()
                              .required("Select if the person has any pre-existing health conditions")
                              .nullable(),
      });
    }
  })
  //Manual address entry textarea validation (manualAddressInput property)
  .when((value, schema) => { 
    const manualEntry = _detailState.getIsAddressManual();
    if (manualEntry) {
      return schema.shape({
        manualAddressInput: yup.string().trim().ensure()
                    .required("Enter more detail")
                    .max(250, (validationObj) => {return `Address must be ${validationObj.max} characters or less`}),
      });
    }
  })
  //Dropdown list of addresses validation (ddlAddress property)
  .when((value, schema) => {
    const address = _detailState.getDdlAddress();
    const manualEntry = _detailState.getIsAddressManual();
    if (address.length === 0 && !manualEntry) {
      return schema.shape({
        ddlAddress: yup.string().trim().ensure().when('postCode', {
          is: (postCode) => postCode.trim() !== "",
          then: yup.string()
                    .required("Select address")
        }),
      });
    }
  })
  .when((value,schema) => {
    const dayVal = _detailState.getDobDay();
    const monthVal = _detailState.getDobMonth();
    const yearVal = _detailState.getDobYear();

    const maxDate = new Date();
    const minDate = new Date();
    minDate.setFullYear(minDate.getFullYear()-100);
    minDate.setHours(0,0,0,0);

    const isApproximateAgeEmpty = _detailState.getApproximateAge() === '';
    const areDateEntriesEmpty = dayVal === '' || monthVal === '' || yearVal === '';

    return schema.shape({
      dob: yup.string().ensure()
      //Make dob required only test if one of the date entry input contains a value 
      //or approximateAge is empty     
      .test(
        'are-date-entries-empty',
        "Enter the date of birth and include a day, month and year",
        (value, context) => {
          return !areDateEntriesEmpty || !isApproximateAgeEmpty;
        })

      //does year contain 4 characters
      .test(
        'is-year-4-characters',
        'Year must be 4 characters',
        (value, context) => {
          return !areDateEntriesEmpty ? yearVal.length === 4 : true;
        }
      )
        
      //Valid date - not allowing 29/2/2022 or 31/7/2000
      .test(
        'is-valid-year',
        'Enter a real date of birth',
        (value, context) => {
          const tempParsedDate = parse(`${dayVal}/${monthVal}/${yearVal}`, 'P', new Date(), { locale: enGB });
          return !areDateEntriesEmpty ? isValid(tempParsedDate) : true;
        })
        
      //Test whether the date is in between 2 dates (at the moment the values are today (the current date) and Date.Today.AddYears(-100) (100 years in the past))
      .test(
        'is-within-limits',
        `Enter a date between ${minDate.toLocaleDateString("en-GB")} and ${maxDate.toLocaleDateString("en-GB")}`,
        (value, context) => {
          const dateInput = parse(`${dayVal}/${monthVal}/${yearVal}`, 'P', new Date(), { locale: enGB });
          return !areDateEntriesEmpty ? ((dateInput >= minDate) && (dateInput <= maxDate)) : true;
        })
      })
  });

export const formOptions = yupValidation;
